import { useQuery } from '@tanstack/react-query';

import { supabase } from '@/lib/supabase';
import type { CourseWithRelations } from '@/lib/types';

const schoolId = import.meta.env.VITE_SCHOOL_ID;

export function useGetAdminPanelCourses() {
	return useQuery<CourseWithRelations[]>({
		queryKey: ['get-admin-panel-courses', schoolId],

		queryFn: async () => {
			const { data, error } = await supabase
				.from('courses')
				.select(
					`
					course_id,
					course_name,
					grade,
					is_ap,
					is_archived,
					course_discipline,
					course_division,
					courses_disciplines (
						discipline:disciplines (
							name
						)
					),
					courses_divisions (
						division:divisions (
							name
						)
					)
				`
				)
				.eq('school_id', schoolId)
				.order('course_name', { ascending: true });

			if (error) throw error;

			// Transform to match expected structure (singular courses_discipline/courses_division)
			const transformedData = data?.map((course) => {
				// Handle both array and object return types from Supabase
				const disciplinesRaw = course.courses_disciplines;
				const divisionsRaw = course.courses_divisions;

				const courseDiscipline = Array.isArray(disciplinesRaw) ? disciplinesRaw[0] : disciplinesRaw;
				const courseDivision = Array.isArray(divisionsRaw) ? divisionsRaw[0] : divisionsRaw;

				return {
					...course,
					courses_discipline: courseDiscipline ?? null,
					courses_division: courseDivision ?? null,
				};
			});

			return (transformedData ?? []) as unknown as CourseWithRelations[];
		},

		staleTime: Infinity,
		refetchOnMount: 'always',
	});
}
